import { bool, func, number, shape } from 'prop-types';
import { FormLabel, InputPersona, Select } from '../../../../components/common';

const TIPOS_CUENTA_ESPECIAL = [
    { value: true, label: 'Contribuyente' },
    { value: false, label: 'Uso único' }
];

const EspecialGateFields = ({ gate, onChange }) => {
    return (
        <>
            <div className="mb-3">
                <FormLabel htmlFor="esContribuyente" required>Tipo de cuenta</FormLabel>
                <Select
                    name="esContribuyente"
                    className="form-control"
                    options={TIPOS_CUENTA_ESPECIAL}
                    value={gate.esContribuyente}
                    onChange={({ target }) => onChange({ esContribuyente: target.value, idPersona: 0 })}
                />
            </div>
            {gate.esContribuyente && (
                <div className="mb-3">
                    <FormLabel htmlFor="idPersona" required>Persona</FormLabel>
                    <InputPersona
                        name="idPersona"
                        className="form-control"
                        value={gate.idPersona}
                        idTipoPersona={0}
                        onChange={({ target }) => onChange({ idPersona: target.value })}
                    />
                </div>
            )}
        </>
    );
};

EspecialGateFields.propTypes = {
    gate: shape({
        esContribuyente: bool,
        idPersona: number
    }).isRequired,
    onChange: func.isRequired
};

export default EspecialGateFields;
